// extracted by mini-css-extract-plugin
export var cardLayout = "_6k-1";
export var paginationContainer = "_6k-0";